import { AbilityBuilder, createMongoAbility } from '@casl/ability'

// "actions": [
//     {
//         "subject": "chat.message",
//         "action": "create",
//         "result": "allowed"
//     }
// ]

export function defineAbility(actions = []) {
    const { can, cannot, build } = new AbilityBuilder(createMongoAbility)

    can('manage', 'all');

    actions.forEach(({ subject, action, result }) => {
        if (result === 'allowed') {
            can(action, subject);
        } else {
            cannot(action, subject);
        }
    })

    return build();
}
